import SamaritanFetch from './httpClient';
import { searchForMember } from './homelesses';

export const checkExistingMember = async ({
    dob,
    memberID,
    memberFirstName,
    memberLastName
}: {
    dob?: string;
    memberID?: string;
    memberFirstName?: string;
    memberLastName?: string;
}) => {
    const searchTerms: string[] = [];
    const searchValues: string[] = [];

    if (dob && memberFirstName && memberLastName && memberID) {
        searchTerms.push('birthday', 'firstName', 'lastName', 'insuranceID');
        searchValues.push(dob, memberFirstName, memberLastName, memberID.toString());
    } else if (dob && memberFirstName && memberLastName && !memberID) {
        searchTerms.push('birthday', 'firstName', 'lastName');
        searchValues.push(dob, memberFirstName, memberLastName);
    } else if (!dob && !memberFirstName && !memberLastName && memberID) {
        searchTerms.push('insuranceID');
        searchValues.push(memberID.toString());
    } else {
        throw new Error(
            'Invalid parameters: Provide either memberID or dob + firstName + lastName.'
        );
    }

    try {
        const response = await searchForMember(searchTerms, searchValues);
        
        // searchForMember can return either an array or an object with samaritan_members
        if (Array.isArray(response)) {
            return response;
        }
        
        return response.samaritan_members || [];
    } catch (error) {
        console.error('Error in checkExistingMember:', error);
        throw error;
    }
};

export const fetchTemplateActions = (org_id: number) =>
    SamaritanFetch.v3(
        `/action_step_templates?action_step_templates[organization_id]=${org_id}`
    );

export const fetchTemplateBeacons = () =>
    SamaritanFetch.v2('/homelesses', {
        query: {
            profile_stage: ['TEMPLATE']
        }
    });

export const submitIntake = (data: any, _beaconId: string) => {
    return SamaritanFetch.v2(`/homelesses`, {
        body: data,
        method: 'POST'
    });
};
